import { render, staticRenderFns } from "./CustomTemplate.vue?vue&type=template&id=10d6f2c7&"
import script from "./CustomTemplate.vue?vue&type=script&lang=ts&"
export * from "./CustomTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports